import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const searchCategoryUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.search_category_list}`;

export const searchCategoryServices = async (lang, parent_id = null) => {
  try {
    const requestBody = parent_id ? { parent_id } : {}; // Only send parent_id if available

    const response = await axios.post(searchCategoryUrl, requestBody, {
      headers: {
        lang: lang || "de",
      },
    });

    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while fetching categories.";
    throw new Error(errorMessage);
  }
};
